module.exports = __webpack_public_path__ + "static/media/question-event.70da5345.png";